import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { BaseDetail } from 'projects/admin/src/app/classes/base-detail';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { DetailModes } from 'projects/admin/src/app/shared/constants';
import { CompetenceModel } from 'projects/core/src/lib/models/competence.model';

@Component({
  selector: 'app-competence-detail',
  templateUrl: './competence-detail.component.html',
  styleUrls: ['./competence-detail.component.scss']
})
export class CompetenceDetailComponent extends BaseDetail implements OnInit {

  public competence: CompetenceModel = null;
  public backRoute = ['/competences'];

  protected identifier = 'competence';

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected transloco: TranslocoService,
    private api: ApiService,
    private route: ActivatedRoute,
  ) {
    super(ui, router, helper, transloco);
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params.id === 'new') {
        this.setInitialized(DetailModes.new);
      } else if (params.id) {
        this.setLoading();
        this.api.getModel('competences', params.id).subscribe({
          next: (result: any) => {
            this.competence = new CompetenceModel().deserialize(result.data);
            this.tabIndex = parseInt(localStorage.getItem(this.identifier + '-tab'), 10);
            this.setInitialized(DetailModes.edit);
          },
          error: (error: any) => {
            this.setFailed(error);
          }
        });
      } else {
        this.onClose();
      }
    });
  }

}
